import { Heading, HeadingProps } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function SectionHeading(props: HeadingProps) {
  return <Heading as={'h2'} size={'lg'} mb={6} {...props} />;
});
